// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ju9g","title":"styles_title__39F7z"};